import * as Sentry from "@sentry/vue";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import I18NextVue from "i18next-vue";
import _ from "underscore";
import { createApp, h } from "vue";
import VueScrollTo from "vue-scrollto";

import App from "./App";
import bus from "./helpers/bus";
import ar from "./i18n/ar";
import en from "./i18n/en";
import store from "./store";

console.log("[RIPLEY WIDGET] main.js module loaded");

const i18nextInit = {
  fallbackLng: "en",
  resources: {
    en: { translation: en },
    ar: { translation: ar }
  }
};

const params = new URLSearchParams(location.search);
// Some of our customers use different schemes for setting the language.
// Try reading the 'hl' parameter.
if (params.get("hl")) {
  i18nextInit.lng = params.get("hl");
}

i18next.use(LanguageDetector).init(i18nextInit);

const defaultOptions = {
  primaryColour: "#4990E2",
  textColour: "#FFFFFF"
};

class RipleyChat {
  constructor(options) {
    try {
      console.log("info:", "[RIPLEY WIDGET]", "Constructor called");
      console.log("[RIPLEY WIDGET] RipleyChat constructor called with options:", options);
      this.options = _.defaults({}, options, defaultOptions);
      this.embed();
      this.initExternalOpen();
    } catch (error) {
      console.error("[RIPLEY WIDGET] Constructor error:", error);
    }
  }

  embed() {
    try {
      console.log("[RIPLEY WIDGET] Embedding widget");
      const div = document.createElement("div");
      document.body.appendChild(div);

      const app = createApp({
        render: () => h(App, { options: this.options })
      });
      app.config.productionTip = true;
      app.config.silent = false;
      app.config.devtools = true;
      app.config.performance = true;
      app.use(store);
      app.use(I18NextVue, { i18next });
      app.use(VueScrollTo);

      if (process.env.NODE_ENV !== "development") {
        Sentry.init({
          app,
          dsn: "https://7ff6d1b91acd48a88c8e4682f7da6ce4@o4505040911335424.ingest.sentry.io/4505367875682304",
          beforeSend(event) {
            const urls = ["https://widget.ripley.chat/js/app.js"];
            if (event.exception && event.exception.values) {
              const frames = event.exception.values[0]?.stacktrace?.frames || [];
              const hasValidUrl = frames.some(frame => urls.includes(frame.filename));
              if (!hasValidUrl) return null;
            }
            return event;
          },
          ignoreErrors: ["network error", "timeout"]
        });
      }

      app.mount(div);
      console.log("[RIPLEY WIDGET] App mounted successfully");
    } catch (error) {
      console.error("[RIPLEY WIDGET] Embed error:", error);
    }
  }

  initExternalOpen() {
    const classname = document.getElementsByClassName("open-ripley-chat");

    Array.from(classname).forEach((el) => {
      el.addEventListener("click", (ev) => {
        ev.preventDefault();
        bus.$emit("openChat");
      });
    });
  }
}

window.RipleyChat = RipleyChat;
window.Chatbot = RipleyChat;
